export const toggleWorkspaceSelection = (
  selected: Set<string>,
  workspaceId: string,
  checked: boolean
): Set<string> => {
  const next = new Set(selected);
  if (checked) {
    next.add(workspaceId);
  } else {
    next.delete(workspaceId);
  }
  return next;
};

export const selectAllWorkspaces = (
  workspaceIds: string[],
  checked: boolean
): Set<string> => {
  if (checked) {
    return new Set(workspaceIds);
  }
  return new Set();
};

export const formatSelectedWorkspaceCount = (count: number): string => {
  return `${count} workspace${count !== 1 ? "s" : ""} valgt`;
};

export const formatBulkDeleteSuccessMessage = (count: number): string => {
  return `${count} workspace${count !== 1 ? "s" : ""} slettet`;
};

export const formatBulkDeletePartialFailureMessage = (
  successCount: number,
  totalCount: number
): string => {
  const failedCount = totalCount - successCount;
  return `${successCount} af ${totalCount} workspaces blev slettet. ${failedCount} kunne ikke slettes.`;
};

export const formatBulkDeleteTotalFailureMessage = (): string =>
  "Ingen workspaces kunne slettes. Prøv igen.";

/** Phrase the user must type to confirm bulk delete (matches single-delete pattern). */
export const formatBulkDeleteConfirmationPhrase = (count: number): string => {
  return `${count} workspace${count !== 1 ? "s" : ""}`;
};

export const formatBulkClaimSuccessMessage = (count: number): string => {
  return `${count} workspace${count !== 1 ? "s" : ""} tildelt ny ejer`;
};

export const formatBulkClaimPartialFailureMessage = (
  successCount: number,
  totalCount: number
): string => {
  const failedCount = totalCount - successCount;
  return `${successCount} af ${totalCount} workspaces blev tildelt ny ejer. ${failedCount} kunne ikke tildeles.`;
};

export const formatBulkClaimTotalFailureMessage = (): string =>
  "Ingen workspaces kunne tildeles ny ejer. Prøv igen.";
